import Vue from 'vue'
import store from './store/index.js'
import Dkfavorites from './Dkfavorites.vue'
import Favorite from './components/Favorite.vue'
import FavoritesCount from './components/FavoritesCount.vue'

Vue.config.productionTip = false


if(document.getElementById("dkfavoritesLinkAll")){
  let linkAll = new Vue({
    components: {
      Favorite,
      Dkfavorites
    },
    // el: '#dkfavorites',
    // render: h => h(Dkfavorites),
    store
  })
  .$mount('#dkfavoritesLinkAll')
}


if(document.getElementById("dkfavoritesCount")){
  let linkAll = new Vue({
    components: {
      FavoritesCount
    },
    store
  })
  .$mount('#dkfavoritesCount')
}

  // slick-slide

  if (window.addEventListener && window.requestAnimationFrame && document.getElementsByClassName) window.addEventListener('DOMContentLoaded', function() {
    if (MutationObserver) {
      let observer = new MutationObserver(function() {
        if (document.querySelector('#dksameFavorites favorite')) {
          [].forEach.call(document.querySelector('#dksameFavorites favorite').parents('.entity-list-card__price'), function(element) {
            loadFavoritesList(element);
          });
        }
      });
      observer.observe(document.body, { subtree: true, childList: true, attributes: true, characterData: true });
    }
    if(document.getElementById("dkfavorite")) {
      [].forEach.call(document.querySelector('#dkfavorite favorite').parents('.tofavorite'), function(element) {
        loadFavoritesList(element);
      });
    }

  }, false);

  function loadFavoritesList(where) {
    new Vue({
      components: {
        Favorite
      },
      store
    })
    .$mount(where)
  }


if(document.getElementById("dkfavoritesList")) {

  loadFavoritesList('#dkfavoritesList')
  // loadFavoritesList('.tofavorite');

  /* let list = new Vue({
    components: {
      Favorite
    },
    store
  })
  .$mount('#dkfavoritesList') */
}

Element.prototype.parents = function(selector) {
  var elements = [];
  var elem = this;
  var ishaveselector = selector !== undefined;

  while ((elem = elem.parentElement) !== null) {
      if (elem.nodeType !== Node.ELEMENT_NODE) {
          continue;
      }

      if (!ishaveselector || elem.matches(selector)) {
          elements.push(elem);
      }
  }

  return elements;
};


// WEBPACK FOOTER //
// ./src/main.js